<template>
    <div v-if="$root.isMobile" class="mobile-page-title">
        <div class="d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-primary btn-sm" @click="toggleFilterSidebar">
                <i class="fal fa-sliders-h"></i> Filtri
            </button>
            <h4 class="mb-0 font-weight-bold flex-grow-1 text-center">
                Clienti
            </h4>
            <div style="width: 80px;"></div>
        </div>
    </div>
    <div class="kt-portlet__head">
        <div v-if="!$root.isMobile">
            <form class="isprint-filter" autocomplete="off">
                <div class="form-group mr-2">
                    <label>Cliente</label><br>
                    <input class="form-control form-control-sm" autocomplete="off" placeholder="Denominazione"
                        type="text" v-model="search.DENOMINAZIONE.VALUE">
                </div>
                <div class="form-group mr-2">
                    <label>Codice Cliente</label><br>
                    <input class="form-control form-control-sm" autocomplete="off" placeholder="Codice Cliente"
                        type="text" v-model="search.CODICE_CLIENTE.VALUE">
                </div>
                <div class="form-group mr-2">
                    <label>Agente</label><br>
                    <input class="form-control form-control-sm" autocomplete="off" placeholder="Descrizione Agente"
                        type="text" v-model="search.DESCRIZIONE_AGENTE.VALUE">
                </div>
                <div class="form-group mr-2">
                    <label>Codice Agente</label><br>
                    <input class="form-control form-control-sm" autocomplete="off" placeholder="Codice Agente"
                        type="text" v-model="search.CODICE_AGENTE.VALUE">
                </div>

            </form>
        </div>
        <div v-else>

            <div v-if="$root.isMobile" class="sidebar" :class="{ 'sidebar-open': isFilterSidebarOpen }">
                <div class="sidebar-header" style="background: linear-gradient(135deg, #ff0000, #800080);">
                    <h5>Filtri</h5>
                    <button type="button" class="close" @click="toggleFilterSidebar">&times;</button>
                </div>
                <div class="sidebar-body">
                    <form class="isprint-filter" autocomplete="off">
                        <div class="form-group">
                            <label>Denominazione</label><br>
                            <input class="form-control form-control-sm" autocomplete="off" placeholder="Denominazione"
                                type="text" v-model="search.DENOMINAZIONE.VALUE">
                        </div>
                        <div class="form-group">
                            <label>Codice Cliente</label><br>
                            <input class="form-control form-control-sm" autocomplete="off" placeholder="Codice Cliente"
                                type="text" v-model="search.CODICE_CLIENTE.VALUE">
                        </div>
                        <div class="form-group">
                            <label>Agente</label><br>
                            <input class="form-control form-control-sm" autocomplete="off"
                                placeholder="Descrizione Agente" type="text" v-model="search.DESCRIZIONE_AGENTE.VALUE">
                        </div>
                        <div class="form-group">
                            <label>Codice Agente</label><br>
                            <input class="form-control form-control-sm" autocomplete="off" placeholder="Codice Agente"
                                type="text" v-model="search.CODICE_AGENTE.VALUE">
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="isprint-grid-container">
        <table v-if="!$root.isMobile" class="isprint-grid shadow" >
            <thead class="isprint-grid-thead">
                <tr style="background: linear-gradient(135deg, #ff0000, #800080); color:#fff">
                    <th style="width:25%"><span>Cliente</span></th>
                    <th style="width:20%"><span>Codice Cliente</span></th>
                    <th style="width:25%"><span>Agente</span></th>
                    <th style="width:20%"><span>Codice Agente</span></th>
                    <th style="width:10%"><span>Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr v-for="cliente in paginatedList.arr" :key="cliente.ID_CLIENTE" style="height:50px">
                    <td style="width:25%;font-size:16px;font-weight:bold">
                        <i class="fad fa-user fa-2x"></i>
                        {{ cliente.DENOMINAZIONE }}
                    </td>
                    <td style="width:20%;font-size:15px;font-weight:bold">
                        <i class="fad fa-barcode fa-2x mr-2"></i>
                        {{ cliente.CODICE_CLIENTE }}
                    </td>
                    <td style="width:25%;font-size:15px;">
                        <i class="fad fa-user-secret fa-2x mr-2" aria-hidden="true"></i>
                        {{ cliente.DESCRIZIONE_AGENTE || '-' }}
                    </td>
                    <td style="width:20%;font-size:15px;font-weight:bold">
                        <i class="fad fa-barcode fa-2x mr-2"></i>
                        {{ cliente.CODICE_AGENTE || '-' }}
                    </td>
                    <td style="width:10%">
                        <div class="btn-group float-right" role="group">
                            <button class="btn btn-info btn-sm float-right" @click="moreInfo(cliente)">
                                <i class="fal fa-info-circle"></i>
                            </button>
                            <!--  <button class="btn btn-warning btn-sm float-right" @click="modificaCliente(cliente)">
                                <i class="fal fa-pencil"></i>
                            </button> -->
                            <!-- <button class="btn btn-danger btn-sm float-right" @click="eliminaCliente(cliente)">
                                <i class="fal fa-trash"></i>
                            </button> -->
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else class="row justify-content-center">
            <div class="col-12 mb-4" v-for="cliente in paginatedList.arr" :key="cliente.ID_CLIENTE">
                <div class="card shadow border-0 text-center p-3" style="border-radius: 20px;">
                    <div class="card-body">
                        <i class="fad fa-building fa-6x  mb-3" aria-hidden="true"></i>

                        <h5 class="card-title">{{ cliente.DENOMINAZIONE }}</h5>

                        <p class="mb-1"><strong>Codice Cliente:</strong> {{ cliente?.CODICE_CLIENTE || '-' }}</p>
                        <p class="mb-1"><strong>Agente:</strong> {{ cliente?.DESCRIZIONE_AGENTE || '-' }}</p>
                        <p class="mb-1"><strong>Codice Agente:</strong> {{ cliente?.CODICE_AGENTE || '-' }}</p>

                        <div class="d-flex justify-content-center mt-3">
                            <!-- <button class="btn btn-warning btn-sm" @click="modificaAgente(agente)"
                                title="Modifica agente">
                                <i class="fal fa-pencil"></i>
                            </button> -->
                            <button class="btn btn-info btn-sm" @click="moreInfo(cliente)" title="Modifica agente">
                                <i class="fal fa-info-circle"></i>
                            </button>
                            <!-- <button class="btn btn-danger btn-sm" @click="deleteAgente(agente)" title="Elimina agente">
                                <i class="fal fa-trash-alt"></i>
                            </button> -->
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="pagine-small">
            <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
                :numpagine="search.PAGINATION.LENGTH"></Pagine>
        </div>
    </div>

    <div class="modal fade" id="popUpCliente" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header modal-header" style="background-color: #3D519C;">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-link fa-fw"></i> Modifica Cliente</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>Cliente:</label>
                        <input type="text" class="form-control form-control-sm" placeholder="Denominazione"
                            v-model="clienteSelezionato.DENOMINAZIONE">
                    </div>
                    <div class="form-group">
                        <label>Codice BP:</label>
                        <input type="text" class="form-control form-control-sm" placeholder="Denominazione"
                            v-model="clienteSelezionato.CODICE_">
                    </div>
                    <div class="form-group">
                        <label>Denominazione:</label>
                        <input type="text" class="form-control form-control-sm" placeholder="Denominazione"
                            v-model="clienteSelezionato.DENOMINAZIONE">
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success btn-block" @click="salvaCliente"><i class="fa fa-check"></i>
                        Salva</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="popUpInfo" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-content shadow-lg rounded-3">
                <div class="modal-header text-white" style="background: linear-gradient(135deg, #ff0000, #800080);">
                    <h5 class="modal-title"><i class="fal fa-info-circle"></i> Dettagli Cliente</h5>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>

                <div class="modal-body">

                    <div class="nav nav-tabs d-flex justify-content-center" id="myTab" role="tablist">
                        <a class="nav-item nav-link active" id="dati-agente-tab" data-toggle="tab" href="#dati-agente"
                            role="tab" aria-controls="dati-agente" aria-selected="true">
                            <i class="fal fa-user-secret"></i> Dati Agente
                        </a>
                        <a class="nav-item nav-link" id="contratti-tab" data-toggle="tab" href="#contratti" role="tab"
                            aria-controls="contratti" aria-selected="false">
                            <i class="fal fa-file-contract"></i> Contratti
                            <span class="badge badge-pill badge-light">{{ clienteSelezionato.CONTRATTI ?
                                clienteSelezionato.CONTRATTI.length : '0' }}</span>
                        </a>
                        <a class="nav-item nav-link" id="fatture-tab" data-toggle="tab" href="#fatture" role="tab"
                            aria-controls="fatture" aria-selected="false">
                            <i class="fal fa-file-invoice-dollar"></i> Fatture
                            <span class="badge badge-pill badge-light">{{ clienteSelezionato.FATTURE ?
                                clienteSelezionato.FATTURE.length : '0' }}</span>
                        </a>
                    </div>


                    <div class="tab-content" id="myTabContent">
                        <!-- Dati Agente Tab -->
                        <div class="tab-pane fade show active" id="dati-agente" role="tabpanel"
                            aria-labelledby="dati-agente-tab">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <div class="card h-100 border-0 shadow-sm">
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item"><strong>Codice:</strong> {{
                                                clienteSelezionato.AGENTE?.CODICE_AGENTE }}</li>
                                            <li class="list-group-item"><strong>Nome:</strong> {{
                                                clienteSelezionato.AGENTE?.DESCRIZIONE_AGENTE }}</li>
                                            <li class="list-group-item"><strong>Area:</strong> {{
                                                clienteSelezionato.AGENTE?.AREA_DI_COMPETENZA }}</li>
                                            <li class="list-group-item"><strong>Fattore:</strong> {{
                                                clienteSelezionato.AGENTE?.FATTORE_AG }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Contratti Tab -->
                        <div class="tab-pane fade" id="contratti" role="tabpanel" aria-labelledby="contratti-tab">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <div class="card h-100 border-0 shadow-sm" style="overflow: auto;">
                                        <div class="card-body" style="max-height: 190px; overflow-y: auto;">
                                            <ul class="list-group list-group-flush">
                                                <li v-for="contratto in clienteSelezionato?.CONTRATTI"
                                                    :key="contratto.ID_CONTRATTO" class="list-group-item py-3">
                                                    <div class="d-flex justify-content-between align-items-center flex-wrap">
                                                        <div class="mr-4 mb-2">
                                                            <span v-if="contratto.PDR && contratto.PDR.length > 1" class="mr-3">
                                                                <i class="fas fa-gas-pump text-danger" title="Gas"></i>
                                                                {{ contratto.PDR }}
                                                            </span>
                                                            <span v-if="contratto.POD && contratto.POD.length > 1" class="mr-3">
                                                                <i class="fas fa-lightbulb text-warning" title="Energia"></i>
                                                                {{ contratto.POD }}
                                                            </span>
                                                        </div>

                                                        <div class="mr-4 mb-2">
                                                            <strong>Codice:</strong> {{ contratto.CODICE_CONTRATTO }}
                                                        </div>

                                                        <div class="mr-4 mb-2">
                                                            <span v-if="contratto.FLG_ATTIVO == 1" class="badge badge-success px-3 py-2">
                                                                <i class="fas fa-check-circle"></i> Attivo
                                                            </span>
                                                            <span v-else class="badge badge-secondary px-3 py-2">
                                                                <i class="fas fa-times-circle"></i> Cessato
                                                            </span>
                                                        </div>

                                                        <div class="text-muted mb-2">
                                                            <span v-if="contratto.DATA_INIZIO_FORNITURA" class="mr-4">
                                                                <i class="far fa-calendar-alt"></i> Dal: {{ contratto.DATA_INIZIO_FORNITURA }}
                                                            </span>
                                                            <span v-if="contratto.DATA_FINE_FORNITURA">
                                                                <i class="far fa-calendar-times"></i> Al: {{ contratto.DATA_FINE_FORNITURA }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="fatture" role="tabpanel" aria-labelledby="fatture-tab">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <div class="card h-100 border-0 shadow-sm" style="overflow: auto;">
                                        <div class="card-body" style="max-height: 190px; overflow-y: auto;">
                                            <ul class="list-group list-group-flush">
                                                <li v-for="fattura in clienteSelezionato?.FATTURE"
                                                    :key="fattura.ID_FATTURA" class="list-group-item">
                                                    <span v-if="(fattura.PDR?.length > 1)" class="ml-2">
                                                        <i class="fas fa-gas-pump text-danger" title="PDR > 1"></i>
                                                    </span>
                                                    <span v-if="(fattura.POD?.length > 1)" class="ml-2">
                                                        <i class="fas fa-lightbulb text-warning" title="POD > 1"></i>
                                                    </span>
                                                    {{ fattura?.NUMERO_FATTURA }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="modal-footer">
                    <button class="btn btn-secondary" data-dismiss="modal">
                        <i class="fal fa-times"></i> Chiudi
                    </button>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import Pagine from '@/components/utils/Pagine.vue';

export default {
    name: "Clienti",
    components: {
        Pagine,
    },
    data() {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                DENOMINAZIONE: { TYPE: 'TEXT', VALUE: '' },
                CODICE_CLIENTE: { TYPE: 'TEXT', VALUE: '' },
                CODICE_AGENTE: { TYPE: 'TEXT', VALUE: '' },
                DESCRIZIONE_AGENTE: { TYPE: 'TEXT', VALUE: '' }
            },
            clienteSelezionato: {},
            arrayClienti: new Array(),
            isFilterSidebarOpen: false,
        };
    },
    methods: {
        toggleFilterSidebar() {
            this.isFilterSidebarOpen = !this.isFilterSidebarOpen;
        },
        moreInfo(cliente) {
            this.clienteSelezionato = utils.clone(cliente)
            var modal = utils.openModal('popUpInfo');
        },
        getClienti() {
            global.utils.get('/dcp/clienti', {}, (response) => {
                // Appiattisci i campi nested dell'agente per permettere il filtro
                this.arrayClienti = response.data.map(cliente => {
                    return {
                        ...cliente,
                        CODICE_AGENTE: cliente.AGENTE?.CODICE_AGENTE || '',
                        DESCRIZIONE_AGENTE: cliente.AGENTE?.DESCRIZIONE_AGENTE || ''
                    };
                });
            });
        },
        creaCliente() {
            this.clienteSelezionato = { ID_CLIENTE: 0 };
            utils.openModal('popUpCliente');
        },
        modificaCliente(cliente) {
            this.clienteSelezionato = utils.clone(cliente);
            utils.openModal('popUpCliente');
        },

        eliminaCliente(cliente) {
            utils.alert.confirm("Sei sicuro di voler procedere con l'eliminazione del cliente? Questa azione cancellerà ogni cliente con le fatture associate.", () => {
                global.utils.delete('/dcp/cliente', { ID_CLIENTE: cliente.ID_CLIENTE }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getClienti();
                    }
                });
            }, this.$root);
        },
        /* salvaCliente(cliente) {
            console.log(cliente.personaGiuridica.DENOMINAZIONE)
                if (cliente.ID_CLIENTE > 0){
                    global.utils.put('/es/cliente', cliente, (response) => {
                        if (response.esito == 0) {
                            utils.alert.success(response.messaggio);
                            this.$refs.popUpCliente.closePopUp();
                            this.getClienti();
                        } else {
                            console.log('Errore durante l\'aggiornamento del cliente:', response);
                        }
                    });
                } else {
                    // Creazione nuovo cliente
                    global.utils.post('/es/cliente', cliente, (response) => {
                        if (response.esito == 0) {
                            utils.alert.success(response.messaggio);
                            cliente.ID_CLIENTE = response.id_inserito;
                            this.$refs.popUpCliente.closePopUp();
                            this.getClienti()
                        } else {
                            console.log('Errore durante la creazione del cliente:', response);
                        }
                    });
                }
            
        }, */
    },
    computed: {
        paginatedList() {
            if (this.$root.test == false) {
                var arr = utils.inGrid(this.arrayClienti, this.search);
                return arr;
            }
            else {
                let result = utils.inGrid(this.arrayClienti, this.search);
                if (Array.isArray(result.arr)) {
                    result.arr = result.arr.filter(cliente => {
                        return cliente.TIPO_RECORD == 'CONDOMINIO';
                    });
                    result.count = result.arr.length;
                } else {
                    console.warn('result.arr non è un array', result);
                }
                return result;
            }
        },
    },
    created() {
        this.getClienti();

    }
};
</script>

<style scoped>
/* Rimpicciolisci Pagine solo su mobile */
@media (max-width: 767px) {
    .pagine-small {
        transform: scale(0.80);
        transform-origin: center;
        margin: -10px 0;
    }
}

.grow {
    transition: all .2s ease-in-out;
}

.grow:hover {
    transform: scale(1.1);
}

.bg-personalizzato-on {
    background-color: blue;
    height: 70px;
}

.bg-personalizzato-off {
    background-color: rgba(5, 5, 247, 0.486);
    height: 70px;
}

.bg-white-pers {
    background-color: whitesmoke;
    color: #4e73df;
}

.pers {
    color: whitesmoke;
}

.sidebar {
    position: fixed;
    top: 0;
    right: -300px;
    width: 220px;
    height: 100%;
    background-color: white;
    z-index: 1045;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
    transition: right 0.3s ease;
}

.sidebar-open {
    right: 0;
}

.sidebar-header {
    padding: 10px;
    background-color: #3D519C;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sidebar-body {
    padding: 20px;
}

.close {
    font-size: 24px;
    cursor: pointer;
}
@media (max-width: 767px) {
    .kt-portlet__head {
        height: 0 !important;
        overflow: hidden;
        margin: 0 !important;
        padding: 0 !important;
    }

    .isprint-grid-container {
        margin-top: 10px !important;
    }
}

@media (min-width: 770px) {
    .isprint-grid-container {
        margin-top: 20px;
        width: auto;
        table-layout: auto;
    }
}

/* Quando la larghezza della finestra è inferiore a 1536px */
@media (max-width: 769px) {
    .isprint-grid-container {
        margin-top: 100px;
    }
}

.mobile-page-title {
    padding: 15px;
    background: linear-gradient(135deg, #ff0000, #800080);
    color: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    position: sticky;
    top: 0;
    z-index: 100;
    margin-bottom: 0;
}

.mobile-page-title h4 {
    margin: 0;
    color: white;
}

.mobile-page-title i {
    margin-right: 8px;
}
</style>
